import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import '../styles/AuthPage.css';

const AuthPage = ({ onLogin }) => {
  const [isLogin, setIsLogin] = useState(true);

  const handleSignupSuccess = (userData) => {
    // Show success message and switch to login form
    setTimeout(() => {
      setIsLogin(true);
    }, 2000);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="brand-title">KampusKonnect</h1>
          <h2 className="portal-title">Affiliate Portal</h2>
          <p className="tagline">Join our affiliate program and start earning</p>
        </div>

        <div className="form-toggle">
          <button 
            className={`toggle-btn ${isLogin ? 'active' : ''}`} 
            onClick={() => setIsLogin(true)}
          >
            Login
          </button>
          <button 
            className={`toggle-btn ${!isLogin ? 'active' : ''}`} 
            onClick={() => setIsLogin(false)}
          >
            Sign Up
          </button>
        </div>

        <div className="form-container">
          {isLogin ? (
            <LoginForm onLogin={onLogin} />
          ) : (
            <SignupForm onSignupSuccess={handleSignupSuccess} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthPage;